import React, { useEffect, useState } from "react";
import { useApi } from "../service/ApiContext";
import { ProfileAPiResponse } from "../features/profile/data/response/LoginApiResponse";
import ProfileClient from "../features/profile/data/api/LoginClient";
import Loader, { LocalStorage } from "../utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import { url } from "inspector";
import { Button } from "reactstrap";
import VideoLandingPage from "./../features/recommendation/vedio-recommendation/pages/VideoLandingPage";
import Login from "./../features/login/pages/LoginPage";
import Logger from "../utils/Logger";

const ComingSoonPage: React.FC = () => {
  const api = useApi();
  const [profileName, setProfileName] = useState<string | null>(null);
  const [Apptoken, setAppToken] = useState<string | null>(null);
  const [urltoken, setAppTokenfromUrl] = useState<string | null>(null);
  const [region, setRegion] = useState<string | null>(null);

  const navigate = useNavigate();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  useEffect(() => {
    Logger.info("Inside the useEffect for URL changes");

    // Extract token and region from URL query parameters
    const tokenFromURL = query.get("token");
    const regionFromURL = query.get("region");

    Logger.info(
      "Query string:",
      query,
      "Token from URL:",
      tokenFromURL,
      "Region from URL:",
      regionFromURL,
      "Window location search:",
      window.location.search,
    );

    // Handling token
    if (tokenFromURL) {
      Logger.info("Token successfully retrieved from URL:", tokenFromURL);
      LocalStorage.setLocalData("access_token", tokenFromURL); // Store token in local storage
    } else {
      Logger.info("No token found in URL. Using appToken:");
      const storedToken = LocalStorage.getLocalData("access_token");
      Logger.info(
        "No token found in URL. Using appToken**************:",
        storedToken,
      );

      if (storedToken) {
        setAppToken(storedToken); // Use the token from local storage if not found in URL
        LocalStorage.setLocalData("access_token", storedToken);
      }
    }

    // Handling region
    if (regionFromURL) {
      Logger.info("Region successfully retrieved from URL:", regionFromURL);
      LocalStorage.setLocalData("region", regionFromURL); // Store region in local storage
    } else {
      Logger.info("No region found in URL.");
    }
    // userProfile();
    // api.login();
  }, []);

  // useEffect(() => {
  //   const storedToken = localStorage.getItem("token");
  //   if (storedToken) {
  //     setAppToken(storedToken);
  //   }

  // }, []);

  const userProfile = async () => {
    Loader.showLoading("Loading...");
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<ProfileAPiResponse>(
        ProfileClient.profileUrl,
      );
      const name = response.data.first_name;
      const institute_id = response.data.institute_id;
      setProfileName(name); // Update state with profile name
      LocalStorage.setLocalData("profileName", name);
      LocalStorage.setLocalData("institute_id", institute_id);
      Logger.info(`Profile name ${name}`);
    } catch (error) {
      Logger.error("Error fetching profile:", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const [showVideoPage, setShowVideoPage] = useState(false);
  const handleButtonClick = () => {
    navigate("/dashboard/recommendation");
  };

  return (
    <div
      style={{
        height: "86vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <center>
        <h1>Coming Soon...</h1>
      </center>
    </div>
  );
};

export default ComingSoonPage;
